import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// themes
import { ActionsWrapper, Content, ContentText } from 'themes/views/modals'
// view components
import { Header } from 'components/Modals/ConfirmDeleteModal'
import { Button, Modal, BUTTON_LAYOUTS } from 'components/UI'

const ConfirmUnlinkPlanItemModal: React.FC = () => {
  // redux
  const {
    hideModal,
    modalData: { handleConfirm, isOpen, title, width }
  } = useModalData({ modalType: Modals.CONFIRM_UNLINK_PLAN_ITEM_MODAL })

  // state
  const [isLoading, setLoading] = React.useState(false)

  // methods
  const handleConfirmClick = async () => {
    try {
      setLoading(true)

      await handleConfirm()

      hideModal()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} width={width} style={{ zIndex: 1302 }}>
      <Header>Unlink {title}</Header>
      <Content>
        <ContentText color={'inherit'} style={{ fontWeight: 500 }}>
          Are you sure you want to remove this link?
        </ContentText>
      </Content>
      <ActionsWrapper>
        <Button shadowLess isLoading={isLoading} layout={BUTTON_LAYOUTS.RED} onClick={handleConfirmClick}>
          Confirm
        </Button>
        <Button shadowLess layout={BUTTON_LAYOUTS.RED_INVERTED} onClick={hideModal}>
          Cancel
        </Button>
      </ActionsWrapper>
    </Modal>
  )
}

export default ConfirmUnlinkPlanItemModal
